<div class="loading-spinner">
  <img src="../../../../assets/images/ellipsis.gif" width="80px" />
</div>
